import React from 'react';

export default function internalImage(props) {
    const {filename, alt} = props;
    if (filename) {
        return (
            <img src={`${window.CARE_CONFIG.image_storage_base_url_v2}${filename}`} alt={alt} title={alt} loading="lazy"/>
        )
    }
    return null;
}




// WEBPACK FOOTER //
// ./src/js/components/internal-image-v2.js